<div class="account-detail-base card">
  <div class="account-detail-base__row">
    <h4 class="account-detail-base__row__title">
      {{ title1 }}
    </h4>
    <div class="account-detail-base__row__content row">
      <div class="col-md-6">
        <div *ngIf="!!cardError">
          <div>
            <img class="product-details-img bb-payment-image-default" [ngClass]="getImageProduct()">
          </div>
        </div>
        <div *ngIf="!cardError">
          <div class="account-detail-base__card-valid-thru" *ngIf="!cardDateUnavailable" i18n="@account-details.valid-thru">
            Valid thru
          </div>
          <bb-payment-card-ui *ngIf="card"
            class="bb-stack__item bb-block bb-block--md bb-payment-card--banesco"
            [style.background-image]="'url(' + cardImageUrl + ')'"
            [paymentCard]="card"
            [paymentCardNumberFormat]="productNumberFormat">
          </bb-payment-card-ui>
        </div>
        <div class="account-detail-base__details-footer">
          <ng-content select="[detailsFooter]"></ng-content>
        </div>
      </div>
      <div class="col-md-6">
        <ng-content select="[details]"></ng-content>
      </div>
    </div>
  </div>
    
  <div *ngIf="title2" class="account-detail-base__row">
    <h4 class="account-detail-base__row__title">
      {{ title2 }}
    </h4>
    <div>
      <ng-content select="[row2]"></ng-content>
    </div>
  </div>
  <div *ngIf="title3" class="account-detail-base__row">
    <h4 class="account-detail-base__row__title">
      {{ title3 }}
    </h4>
    <div>
      <ng-content select="[row3]"></ng-content>
    </div>
  </div>
  <div *ngIf="title4" class="account-detail-base__row">
    <h4 class="account-detail-base__row__title">
      {{ title4 }}
    </h4>
    <div>
      <ng-content select="[row4]"></ng-content>
    </div>
  </div>

  <div class="account-detail-base__row" *ngIf="additionalCards.length">
    <h4 class="account-detail-base__row__title" i18n="@@product.details.additionalCards">
      Additional Cards
    </h4>
    <div class="account-detail-base__additional-cards">
      <div *ngFor="let additionalCard of additionalCards" class="account-detail-base__additional-cards__card">
        <bb-payment-card-ui
          class="bb-stack__item bb-block bb-block--md  bb-payment-card--banesco"
          [style.background-image]="'url(' + additionalCardImageUrl + ')'"
          [paymentCard]="additionalCard"
          [paymentCardNumberFormat]="productNumberFormat">
        </bb-payment-card-ui>
      </div>
    </div>
  </div>
</div>

<!--TODO handle translations in a better way-->
<div style="display: none;">
  <span i18n="@@product-details.h2.accountDetails">Account Detail</span>
  <span i18n="@@product-details.h2.balances">Balances</span>
  <span i18n="@@product-details.h2.statements">Statements</span>
  <span i18n="@@product-details.h2.otherInfo">Other information</span>
  <span i18n="@@product-details.h2.otherInformation">Other information</span>
  <span i18n="@@product-details.greyLabel">Statement payment pending</span>
  <span i18n="@@product-details.paidLabel">Paid</span>
  <span i18n="@@product-details.successLabel">Statement paid</span>
  <span i18n="@@product-details.overdueLabel">Statement payment overdue</span>
  <span i18n="@@product-details.infoLabel">Total payments made for the pending statement</span>
  <span i18n="@@product-details.h2.credit">Credit</span>
  <span i18n="@@product-details.h2.details">Details</span>
  <span i18n="@@product-details.h2.installmentInfo">Installment information</span>
  <span i18n="@@product-details.h2.overduePayments">Overdue payments</span>
</div>